import type {
  GetProcessorsQuery,
  GetProcessorsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_PROCESSORS: TypedDocumentNode<
  GetProcessorsQuery,
  GetProcessorsQueryVariables
> = gql`
  query GetProcessors {
    processors {
      processors {
        id
        code
        createdAt
        updatedAt
      }
    }
  }
`;
